// extracted by mini-css-extract-plugin
module.exports = {"section":"products-module--section--1PAfl","wrapper":"products-module--wrapper--5hyp1","heading":"products-module--heading--EKQO_"};